import React, { ReactNode } from 'react'

interface InfoCardProps {
    className?: string
    children?: ReactNode
}

export const InfoCard: React.FC<InfoCardProps> = ({ className, children }) => {
    return <div className={`${className} text-center p-[15px] rounded`}>{children}</div>
}
